export const GET_LOGO_IMG_LINKS = 'background/GET_LOGO_IMG_LINKS';
export const CLOSE_BACKGROUND_IMAGE = 'background/CLOSE_BACKGROUND_IMAGE';
